/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для списка товаров на странице категории 2 уровня.
   */
  app.CategoryItemsView = app.RestItemsView.extend({
    el: '.backbone-items-view',

    // Кол-во товаров в строке.
    itemsPerRow: 0,

    events: {},
    additionalOptions: [
      'router',
      'currency',
      'mainWindow',
      'fader',
      'withEmptyFilter',
      'isGalleryEnabled',
      'activeFilterPageModel',
      'isRootFilterPage',
      'isDynamicDeliverySegment',
      'isShowOneItemInSearch',
      'wish',
      'createNotification',
    ],
    /**
     * @inheritDoc
     */
    run: function () {
      this.isSearchResultsModel = app.Search && this.model instanceof app.Search;
      this.childViews.itemViews = [];
      this.nothingFoundTemplate = app.helpers.TemplateHelper.getTemplate('#search-nothing-found');
      this.listenTo(this.model, 'sync search-collection:reset', this.createItemView);
      this.initDynamicItemDeliveryCost();
      this.calculateItemsPerRow();
      if (typeof app.ChosenFilters !== 'undefined') {
        this.chosenFilters = new app.ChosenFilters();
      }
      this.isClearContainer = false;
      if (!app.isMobile) {
        this.listenToOnce(this, 'rendered', this.initGridView);
      }
      this.initFilters();
      this.listenTo(this.router, 'clear', this.clear);
      this.listenTo(this.mainWindow, 'window.resize.debounced', this.calculateItemsPerRow);
      this.listenTo(this, 'rendered', _.debounce(this.calculateItemsPerRow, 1000));

      this.hasNewLoader = app.features.is_filters_auto_apply && app.LoaderView;

      if (this.hasNewLoader) {
        this.childViews.loader = new app.LoaderView({
          contentWrapper: this.$el.parent(),
          withFade: true,
          mainWindow: this.mainWindow,
          sizeClass: app.isMobile ? 'medium' : 'big',
        });
        this.childViews.loader.listenTo(app.filters, 'loader:show', this.childViews.loader.render);
        this.childViews.loader.listenTo(this.model, 'sync', this.childViews.loader.remove);
        this.childViews.loader.listenTo(this, 'rendered', this.childViews.loader.remove);
      }
    },

    /**
     * Вычисляет количество товаров на строке.
     */
    calculateItemsPerRow: function () {
      var containerWidth = this.$el.width(),
        itemView = _.get(this.childViews.itemViews, '[0].$el', this.$('.tile').eq(0));
      if (itemView.length && itemView.width() > 0) {
        var itemWidth = itemView.width(),
          result = Math.floor(containerWidth / Math.floor(itemWidth));
        if (this.itemsPerRow !== result) {
          this.itemsPerRow = result;
          this.trigger('itemsPerRowCalculated');
        }
      }
    },

    /**
     * Рендерит шаблон "ничего не найдено"
     */
    renderNothingFound: function () {
      this.$el.html(this.nothingFoundTemplate());
      if (app.preloader) {
        app.preloader.remove();
      }
      $('.js-filters-aside').toggleClass('not_display', true);
      this.trigger('rendered');
      this.isClearContainer = false;
    },
    /**
     * Ставим флаг для очищения контейнера.
     */
    clear: function () {
      this.isClearContainer = true;
    },
    /**
     * Инициализируем работу с фильтрами.
     */
    initFilters: function () {
      /* отключаем фильтры в подарках */
      if (app.jsCatalogType !== 'gifts' && app.enableFilters && !app.isMobile) {
        app.filters = new app.Filters.FiltersView({
          collection: this.model,
          router: this.router,
          settlement: this.settlement,
          fader: this.fader,
          withEmptyFilter: this.withEmptyFilter,
          activeFilterPageModel: this.activeFilterPageModel,
          autoApplyFilters: app.features.is_filters_auto_apply,
          mainWindow: this.mainWindow,
          isRootFilterPage: this.isRootFilterPage,
          chosenFilters: this.chosenFilters,
        });
        app.EventBus.trigger('CategoryItemsView:initFilters');
      }
    },

    /**
     * Создание views для товаров в списке и передача модели, полученной из коллекции.
     */
    createItemView: function () {
      /* При бесконечном скролле коллекцией триггерится reset. Чтобы избежать повторного рендеринга,
      нужно убедиться, что reset вызван именно при fetch'e коллекции */
      if (arguments.length === 2 && arguments[1].isFetched) {
        return;
      }
      var that = this;
      // если не в бесконечном скролле, удаляем ссылки на вьюхи
      if (this.model.mode !== 'infinite' || this.model.state.currentPage === 1) {
        var itemsLength = this.childViews.itemViews.length;
        for (var i = 0; i < itemsLength; i++) {
          this.childViews.itemViews[i].remove();
        }
        this.childViews.itemViews.splice(0, (itemsLength + 1));
      }
      // если нет ни одного товара в коллекции, то выводим "Ничего не найдено"
      if (this.model.state.totalRecords === 0) {
        this.renderNothingFound();
        return;
      }
      // если это поиск и найден только один товар и не задан фильтр, то перенаправляем на страницу товара
      if (
        !this.isShowOneItemInSearch
        && this.isSearchResultsModel
        && this.model.state.totalRecords === 1
        && (!this.model.filter || this.model.filter === 'null')
      ) {
        var singleModel = this.model.models[0],
          url = '';
        if (singleModel) {
          url = singleModel.get('itemUrl');
          if (url) {
            url = url.replace(/&amp;/g, '&');
            app.helpers.RedirectHelper.locationAssign(url);
            return;
          }
        }
      }
      if (this.hasNewLoader) {
        this.childViews.loader.render();
      }
      // при загрузке страницы не нужно рендерить список товаров, если товары уже есть на странице
      if (this.model.fetchCounter === 1) {
        var foundElementsCounter = 0;
        try {
          _.each(this.model.models.slice(-this.model.state.itemsInResponse), function (item, key) {
            var element = that.$('[data-key=' + item.id + ']'),
              categoryItemView;
            if (element.length) {
              categoryItemView = new app.CategoryItemView({
                el: $(element),
                model: item,
                collection: that.model,
                cart: that.cart,
                user: that.user,
                currency: that.currency,
                mainWindow: that.mainWindow,
                settlement: that.settlement,
                key: key,
                isGalleryEnabled: that.isGalleryEnabled,
                isNewBadgeColors: app.features.is_new_badge_colors,
              });
              that.childViews.itemViews.push(categoryItemView);
              foundElementsCounter += 1;
              categoryItemView.render(element);
            } else {
              throw new Error('The element corresponding to model with article: ' + item.get('sid') + ' was not found on page.');
            }
          });
        } catch (error) {
          if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
            Raven.captureException(error);
            if (this.model.mode === 'infinite') {
              this.isClearContainer = true;
            }
          } else {
            throw error;
          }
        }
        if (foundElementsCounter === this.model.state.itemsInResponse) {
          if (app.preloader) {
            app.preloader.remove();
          }
          this.trigger('rendered');
          this.isClearContainer = false;
          return;
        }
      }
      // рендерим товары как обычно с полной перерисовкой страницы.
      if (!this.hasNewLoader) {
        app.preloader.render();
      }
      if (this.model.mode === 'server' || this.isClearContainer) {
        this.isClearContainer = false;
        $(that.el).html('');
      }
      if (app.isMobile) {
        this.$el.removeClass('catalog-tiles');
      }
      if (this.model.viewtype === 'list') {
        this.$el.removeClass('products');
        this.$el.removeClass('products products_xxl');
        if (app.jsCatalogType !== 'parts'){
          this.$el.addClass('catalog__list');
        }
      }
      if (this.model.viewtype === 'cards' && !app.isMobile) {
        this.$el.removeClass('products products_xxl');
        this.$el.removeClass('catalog__list');
        this.$el.addClass('products');
      }
      if (this.model.viewtype === 'xxl') {
        this.$el.removeClass('products');
        this.$el.removeClass('catalog__list');
        this.$el.addClass('products products_xxl');
      }
      if (this.model.viewtype === 'tiles') {
        this.$el.removeClass('products products_xxl');
        this.$el.removeClass('catalog__list');
        this.$el.addClass('catalog-tiles');
      }

      _.each(this.model.models.slice(-this.model.state.itemsInResponse), function (num, key) {
        var categoryItemView = new app.CategoryItemView({
          model: num,
          collection: that.model,
          cart: that.cart,
          user: that.user,
          currency: that.currency,
          mainWindow: that.mainWindow,
          settlement: that.settlement,
          key: key,
          isGalleryEnabled: that.isGalleryEnabled,
          isNewBadgeColors: app.features.is_new_badge_colors,
        });
        that.childViews.itemViews.push(categoryItemView);
        try {
          that.el.appendChild(categoryItemView.render().el);
        } catch (e) {
          if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
            Raven.captureException(e);
          } else {
            throw e;
          }
        }
      });
      this.isClearContainer = false;
      this.trigger('rendered');
      $('.js-filters-aside').toggleClass('not_display', false);
      app.preloader.remove();
    },
    /**
     * @inheritdoc
     */
    getSelectedItems: function () {
      return this.childViews.itemViews.filter(function (itemView) {
        return itemView.$el.hasClass('selected');
      });
    }
  });
})(jQuery);

}.call(window));